import React from 'react'
import {useFormikContext} from 'formik'
import {ServiceRequestStep} from '../../../genericComponents/formTemplate/steps/ServiceRequestStep'
import {Description} from '../../../../../genericComponents/typographie/Description'
import {WorkflowSelector} from '../../../model/WorkflowSelector'
import {ServiceEnum} from '../../../../model/ServiceEnum'
import {Label} from '../../../../../genericComponents/typographie/Label'
import {ItemCreationForm} from '../../../../model/NewItemInput'

export const ReviewNewItemsForm = ({service}: { service: ServiceEnum }) => {
    const formik = useFormikContext<ItemCreationForm>()
    return (
        <ServiceRequestStep>
            <Description>Please <b>review</b> your selections and submit.</Description>

            <div data-testid="manufacturer-item-creation-summary" className="service-request-form-summary">
                <Label className="form-summary-label">Part Number</Label>
                <span className="form-summary-value">{formik?.values?.partNumber ?? '-'}</span>

                <Label className="form-summary-label">Defined by</Label>
                <span className="form-summary-value">{formik?.values?.definedByOrganization?.label ?? '-'}</span>

                <Label className="form-summary-label"> Technical Classification</Label>
                <span className="form-summary-value">{formik?.values?.technicalClassificationNode?.label ?? '-'}</span>

                <Label className="form-summary-label">Under Non Disclosure Agreement</Label>
                <span className="form-summary-value">{formik?.values?.underNDA ? <>Yes</> : <>No</>}</span>
            </div>

            <WorkflowSelector service={service}/>
        </ServiceRequestStep>
    )
}
